/*
 * @title: 
 * @Author: wangshuai
 * @Date: 2024-10-30 15:46:32
 * @FilePath: \飞行-运控\src\api\model\taskFly.js
 * @Description: 长期任务模块接口
 * 
 */
import config from "@/config";
import http from "@/utils/request";

export default {
	queryDeclareServiceStation: {
		url: `${config.MAIN_URL}/api/v1/lss/stationInfo/queryDeclareServiceStation`,
		name: "长期任务-可申报服务站",
		get: async function () {
			return await http.get(this.url);
		},
	},
	queryLongTimePlanList: {
		url: `${config.MAIN_URL}/api/v1/lss/longTimePlan/queryLongTimePlanList`,
		name: "长期任务-查询长期计划",
		get: async function (data) {
			return await http.post(this.url,data);
		},
	},
	addLongTimePlan: {
		url: `${config.MAIN_URL}/api/v1/lss/longTimePlan/addLongTimePlan`,
		name: "长期任务-添加长期计划",
		post: async function (data) {
			return await http.post(this.url,data);
		},
	},
	updateLongTimePlan: {
		url: `${config.MAIN_URL}/api/v1/lss/longTimePlan/updateLongTimePlan`,
		name: "长期任务-更新长期计划",
		post: async function (data) {
			return await http.post(this.url,data);
		},
	},
	queryLssPlanType: {
		url: `${config.MAIN_URL}/api/v1/lss/lssPlanType/queryLssPlanType`,
		name: "长期任务-根据服务站获取任务类型",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
	queryPlanDetails: {
		url: `${config.MAIN_URL}/api/v1/lss/longTimePlan/queryPlanDetails`,
		name: "长期任务-获取长期计划详情",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
	updateApprovalPlan: {
		url: `${config.MAIN_URL}/api/v1/lss/longTimePlan/updateApprovalPlan`,
		name: "长期任务-修改审核状态",
		post: async function (data) {
			return await http.post(this.url,data);
		},
	},
	getLssElement: {
		url: `${config.MAIN_URL}/api/v1/lss/lssPlottingElement/getLssElement`,
		name: "长期任务-查询标绘元素",
		get: async function (data) {
			return await http.get(this.url,data);
		},
	},
	addOrModify: {
		url: `${config.MAIN_URL}/api/v1/lss/lssPageDisplayInfo/addPageDisplay`,
		name: "长期任务-新增或编辑表格展示字段",
		post: async function (data) {
			return await http.post(this.url,data);
		},
	},
	query: {
		url: `${config.MAIN_URL}/api/v1/lss/lssPageDisplayInfo/getPageDisplay`,
		name: "长期任务-查询表格展示字段",
		post: async function (params) {
			return await http.get(this.url,params);
		},
	},
	copyLongtimeplan: {
		url: `${config.MAIN_URL}/api/v1/lss/longTimePlan/copyLongtimeplan`,
		name: "长期任务-复制长期计划",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
	addAttachmentInfo: {
		url: `${config.MAIN_URL}/api/v1/lss/lssAttachmentInfo/addAttachmentInfo`,
		name: "长期任务-计划任务附件新增",
		post: async function (data) {
			return await http.post(this.url,data);
		},
	},
	queryAttachmentInfo: {
		url: `${config.MAIN_URL}/api/v1/lss/lssAttachmentInfo/queryAttachmentInfo`,
		name: "长期任务-附件信息查询",
		get: async function (params) {
			return await http.get(this.url,params);
		},
	},
	delAttachmentInfo: {
		url: `${config.MAIN_URL}/api/v1/lss/lssAttachmentInfo/delAttachmentInfo`,
		name: "长期任务-data",
		post: async function (data) {
			return await http.post(this.url,data);
		},
	},
};
